var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/personal-stylist/apparel-text-inputs.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12 o-large--8\">\n\n        <div class=\"c-form__field\">\n\n            <label for=\"pinterest_link\" class=\"c-form__label\">\n                ";
output += runtime.suppressValue((lineno = 7, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_pinterest-label"])), env.opts.autoescape);
output += "\n            </label>\n\n            <input type=\"text\" name=\"pinterest_link\" class=\"c-form__text\" maxlength=\"255\" data-qa-pinterest-link/>\n\n        </div>\n\n    </div>\n\n</div>\n\n<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12 o-large--8\">\n\n        <div class=\"c-form__field\">\n\n            <label for=\"wishlist_Name\" class=\"c-form__label\">\n                ";
output += runtime.suppressValue((lineno = 25, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_wishlist-label"])), env.opts.autoescape);
output += "\n            </label>\n\n            <input type=\"text\" name=\"wishlist_Name\" class=\"c-form__text\" maxlength=\"30\" data-qa-wish-list-name/>\n\n        </div>\n\n    </div>\n\n</div>\n\n<div class=\"o-row\">\n\n    <div class=\"o-column o-extra-small--12 o-large--8\">\n\n        <div class=\"c-form__field\">\n\n            <label for=\"wishlist\" class=\"c-form__label\">\n                ";
output += runtime.suppressValue((lineno = 43, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["personal-stylist_what-else-label"])), env.opts.autoescape);
output += "\n            </label>\n\n            <textarea id=\"wishlist_more_info\" name=\"wishlist_more_info\" rows=\"5\" cols=\"40\" class=\"c-form__textarea js-textarea\" maxlength=\"500\" data-qa-more-info></textarea>\n\n            ";
if((lineno = 48, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.genericEmailService.personalStylistLocation"]))) {
output += "\n                <input type=\"hidden\" name=\"preferred_contact_method\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"personalStylistLocation"), env.opts.autoescape);
output += "\" />\n            ";
;
}
output += "\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/personal-stylist/apparel-text-inputs.j2"] , dependencies)